
<div class="PolicyContainer">
  <header>
    <h1>Help</h1>
  </header>

  <section class="policy-content">
    <h2>How to Delete Your Account on the {{Company_Name}} Platform</h2>

    <p>You may deactivate or permanently delete your {{Company_Name}} account at any time through our desktop web
      portal, mobile WAP site, or mobile application, subject to applicable terms and conditions. Once your account is
      deactivated or deleted, we will stop sharing your data.</p>

    <p>However, certain information may still need to be retained. Your Personal Data and Transactional Data will be
      stored only as long as necessary for the purposes for which it was collected, after which it will be securely
      disposed of. Please note that record retention required by law will continue to apply, including under the
      Securities and Exchange Board of India (Investment Advisers) Regulations, 2013.</p>

    <p>As per the Prevention of Money Laundering Act (PMLA) guidelines and SEBI regulations, transaction logs must be
      preserved for up to five years even after account deletion. In case of any ongoing legal or regulatory
      proceedings, or if we receive a legal directive, we may be required to retain your data for a longer period in
      compliance with applicable laws.</p>

    <p>To delete your account, login to your account, Go to Account and use the delete option to delete account.</p>
    <p>For support please call us on {{Company_MoblNo}} or email us on {{Company_Email}}</p>
  </section>

  <div>
    <img src="../../assets/images/DelAcc_Web1.png" alt="How to Delete Account">
    <img src="../../assets/images/DelAcc_Web2.png" class="img2" alt="How to Delete Account">
  </div>

</div>